import React, { useEffect, useRef, useState } from "react";
import { useFormikContext, useField } from "formik";
import DatePicker from "react-datepicker";
import { setMinutes, setHours } from "date-fns";
import { Input } from 'semantic-ui-react';
import moment from 'moment';

export const DateBooking = ({ ...props }) => {
    const { setFieldValue } = useFormikContext();
    const [field] = useField(props);
    const datePickerRef = useRef();

    const handleOnKeyDown = event => {
        // if (event?.keyCode === 13 || event?.which === 13) {
        // datePickerRef.current.setOpen(true);
        // }
        // else 
        if(event?.keyCode === 9 || event?.which === 9){
            datePickerRef.current.setOpen(false);
        }
  };

    //DD-MM-YYYY
    useEffect(() => {
        if (props.tname) {
            setFieldValue(props.tname, field.value ? moment(field.value).format('YYYY-MM-DD HH:mm') : null)
        }
    }, [])
    return (
        <DatePicker
            isClearable={props.disabled ? false : true}
            popperClassName="dateTime"
            {...field}
            {...props}
            selected={(field.value && new Date(field.value)) || null}
            onChange={(val) => {
                if (props.tname) {
                    setFieldValue(props.tname, val ? moment(val).format('YYYY-MM-DD HH:mm') : null)
                }
                if (props?.values?.budgeted_time) {
                    setFieldValue(props.setDeliveryDate, moment(val).add(props.values.budgeted_time,
                        'hours').format('YYYY-MM-DD HH:mm'))
                }
                setFieldValue(field.name, val);
            }}
            preventOpenOnFocus={false}
            ref={datePickerRef}
            onKeyDown={handleOnKeyDown}
       customInput={<Input defaultValue={props.defaultValue} className="dateWidth" icon="calendar alternate outline" iconPosition="left" />}
        />
    );
};
